import React, { useEffect } from "react";
import { X } from "lucide-react";

export default function VideoModal({ video, onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  if (!video) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-8" onClick={onClose}>
      <div className="absolute inset-0 bg-black/90 backdrop-blur-sm" />
      <div className={`relative z-10 w-full ${video.vertical ? "max-w-[420px]" : "max-w-5xl"}`} onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <span className="text-white/80 text-sm uppercase tracking-[0.14em]" style={{ fontFamily: "Space Grotesk" }}>
            {video.title}
          </span>
          <button onClick={onClose} className="text-white/70 hover:text-white transition-colors" aria-label="Chiudi video">
            <X size={28} />
          </button>
        </div>
        <div className="relative w-full" style={{ paddingBottom: video.vertical ? "177.78%" : "56.25%" }}>
          <iframe
            className="absolute inset-0 w-full h-full"
            src={`https://www.youtube.com/embed/${video.id}?autoplay=1&rel=0`}
            title={video.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
}
